import React, { useState } from "react";
import "./Managercompany.css";
import Managerabout from './Managerabout'
// import Attendance from './Attendance';
// import Structure from './Structure';
// import Chartstructure from './Chartstructure';

/* ---------- Dummy Section Component ---------- */
const DummySection = ({ title }) => {
  return (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );
};

/* ---------- Main Company Component ---------- */
const Company = () => {
  const tabs = [
    { id: 1, name: "ABOUT US", component: () => <Managerabout title="About Us" /> },
    { id: 2, name: "STRUCTURE", component: () => <DummySection title="Company Structure" /> },
    { id: 3, name: "POLICIES", component: () => <DummySection title="Company Policies" /> },
    { id: 4, name: "ATTENDANCE", component: () => <DummySection title="Attendance Management" /> },
    { id: 5, name: "LEAVE", component: () => <DummySection title="Leave Management" /> },
    { id: 6, name: "LEVELS", component: () => <DummySection title="Employee Levels" /> },
    { id: 7, name: "DESIGNATION", component: () => <DummySection title="Designation" /> },
    { id: 8, name: "DEPARTMENT", component: () => <DummySection title="Department" /> },
    { id: 9, name: "SATURATED", component: () => <DummySection title="Saturated Roles" /> },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="company-container">

      {/* 🔹 Inline CSS */}
      <style>{`
  /* Default (Mobile first) – kuch change nahi */
  .company-scroll-container {
    position: static;
    background: #fff;
  }

  .company-buttons-row {
    display: flex;
    // gap: 10px;
    flex-wrap: wrap;
  }

  .company-button {
    padding: 8px 16px;
    border: none;
    background: #f0f0f0;
    cursor: pointer;
    border-radius: 6px;
    white-space: nowrap;
  }

  .company-button.active {
    background: #7564e6;
    color: #fff;
  }

  /* ✅ Desktop / Laptop only */
  @media (min-width: 769px) {
    .company-scroll-container {
      position: sticky;
      top: 0;
      z-index: 100;
      padding: 10px 0;
    }
  }
`}</style>


      {/* Tabs */}
      <div className="company-scroll-container">
        <div className="company-buttons-row">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`company-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      {/* Active Section */}
      <div className="component-display">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};


export default Company;
